import { graphql, useStaticQuery } from 'gatsby';

import { useFlatten } from './use-flatten';
import { getProperty } from 'utils';

export const useStaticQuickinfo = () => {
	const results = useStaticQuery(query) || {};
	const key = 'squidex.findQuickinfoSingleton';

	return useFlatten(getProperty(results, key) || {});
};

const query = graphql`
	query useQuickinfoQuery {
		squidex {
			findQuickinfoSingleton {
				id
				data {
					mail {
						de {
							title
							text
							link {
								data {
									path {
										de
									}
								}
							}
							linkText
						}
					}
					phone {
						de {
							title
							text
						}
					}
					condominium {
						de {
							title
							text
						}
					}
				}
			}
		}
	}
`;
